import { secondaryBrandButtonSmall } from 'components/Globals/Base/Button/buttonStyles';
import { css } from 'styled-components';
import { type Theme, getBodyStyle, getColor } from 'styles/theme';
import { breakpoint } from 'styles/globals';

export const topHighlightCard = css<{ theme: Theme }>`
  & > .top-highlight-card {
    .top-highlight-card-widget {
        padding: 20px 20px;
        margin-left: -20px;
        margin-right: -20px;
        display: flex;
        flex-direction: column;
        background: #1A725C;
        
        @media (${breakpoint.mdMin}) {
            background: linear-gradient(90deg, #25B28E 0%, #19715B 23.84%);
            flex-direction: row;
            padding: 16px 32px;
            margin-left: -32px;
            margin-right: -32px;
        }

        @media (${breakpoint.lgMin}) {
            padding: 16px 48px;
        }

        @media (${breakpoint.xlMin}) {
            margin-left: -48px;
            margin-right: -48px;
        }

        h4 {
            ${getBodyStyle('graphikCond', { default: 'xlarge' }, 'semiBold')};
            line-height: 28px;
        }

        p:not(.highlight-card-link) {
            ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
        }

        h4, p:not(.highlight-card-link) {
            color: ${getColor('textWhite')};
            width: 100%;
        }
    
        img {
            min-width: 150px;
            max-width: 150px;
            min-height: 96px;
            max-height: 96px;
            border-radius: 5px;

            @media (${breakpoint.mdMin}) {
                min-width: 140px;
                max-width: 140px;
                min-height: 88px;
                max-height: 88px;
            }
        }
    }
  }
`;

export const contentHighlightCard = css<{ theme: Theme }>`
  .content-highlight-card-widget {
    padding: 20px 20px;
    display: flex;
    flex-direction: column;
    background: #1A725C;
    max-width: 980px;
    margin: auto;

    @media (${breakpoint.mdMin}) {
        background: linear-gradient(90deg, #25B28E 0%, #19715B 23.84%);
        flex-direction: row;
        padding: 32px 32px;
    }

    img {
        min-width: 150px;
        max-width: 150px;
        min-height: 96px;
        max-height: 96px;
        border-radius: 5px;

        @media (${breakpoint.mdMin}) {
            min-width: 170px;
            max-width: 170px;
            min-height: 108px;
            max-height: 108px;
        }
    }

    h4 {
        ${getBodyStyle('graphikCond', { default: 'xxlarge' }, 'semiBold')};
        line-height: 38px;
    }

    p:not(.highlight-card-link) {
        ${getBodyStyle('graphikCond', { default: 'large' }, 'semiBold')};
    }
    
    h4, p:not(.highlight-card-link) {
        color: ${getColor('textWhite')};
        width: 100%;
    }

    .highlight-card-info .wp-block-group__inner-container {
        @media (${breakpoint.lgMin}) {
            margin-left: 32px;
        }
    }

    .highlight-card-link {
        width: auto;
        margin: 8px 0 0;
        padding: 0;

        a {
            @media (${breakpoint.mdMin}) {
                width: auto;
            }
        }
    }
  }
`;

export const commonHighlightCardsStyles = css<{ theme: Theme }>`
  .highlight-card-info .wp-block-group__inner-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-top: 20px;
    gap: 8px;
    width: 100%;


    @media (${breakpoint.mdMin}) {
        margin-top: 0;
        margin-left: 20px;
        justify-content: flex-start;
        text-align: start;
        width: auto;
    }

    @media (${breakpoint.lgMin}) {
        margin-left: 40px;
    }
  }   

  .highlight-card-info {
    display: flex;
    align-items: center;
    width: 100%;

    @media (${breakpoint.mdMin}) {
        width: auto;
    }
  }

  .highlight-card-link {
    display: flex;
    align-items: center;
    margin-top: 16px;
    width: 100%;

    @media (${breakpoint.mdMin}) {
        margin: 0 0 0 auto;
        padding-left: 40px;
        width: auto;
    }

    a {
        width: 100%;
        text-transform: uppercase;
        ${secondaryBrandButtonSmall};  
            
        @media (${breakpoint.mdMin}) {
            width: 145px;
        }

        &::after {
            display: none;
        }
    }                  
  }

  .wp-block-image {
    display: flex;
    align-items: center;
    justify-content: center;

    @media (${breakpoint.mdMin}) {
      justify-content: flex-start;
    }
  }

  .expiration-date-widget {
    display: none;
  }
`;
